import React, { FC, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import OvTextButton from '../atoms/OvTextButton';
import OvVideoStateNotice from './OvVideoStateNotice';
import { getReplacementNotice } from '../../../common/utils/video-notice-utils';
import { useVideoReplacement } from '../../../hooks/use-video-replacement';
import { useVideoUploads } from '../../../hooks/use-video-uploads';

interface OvVideoReplacementNoteProps {
  replacementId: string;
  variant?: 'compact' | 'full';
  children?: ReactNode;
}

const OvVideoReplacementNote: FC<OvVideoReplacementNoteProps> = ({
  replacementId,
  variant = 'compact',
  children = null,
}) => {
  const { t } = useTranslation();
  const { uploads } = useVideoUploads();
  const {
    data: replacement,
    isPending,
    isError,
    refetch,
  } = useVideoReplacement(replacementId);

  if (isPending) {
    return null;
  }

  if (isError) {
    return (
      <OvVideoStateNotice
        notice={{ kind: 'replacementUnavailable' }}
        variant={variant}
      >
        <OvTextButton type="button" onClick={() => refetch()}>
          {t('common.actions.retry')}
        </OvTextButton>
      </OvVideoStateNotice>
    );
  }

  return (
    <OvVideoStateNotice
      notice={getReplacementNotice(
        replacement,
        uploads.find(({ videoId }) => videoId === replacementId)
      )}
      variant={variant}
    >
      {children}
    </OvVideoStateNotice>
  );
};

export default OvVideoReplacementNote;
